import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Otp.css";
import axios from "axios";
import { BASE_URL } from "../../BASE_URL";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../Components/Loader/Loader";

const Otp = () => {
  const [loading, setLoading] = useState(false)
  let navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(120); // 2 minutes timer
  const [canResend, setCanResend] = useState(false);
  const handleChangeOtp = (e) => {
    setOtp(e.target.value);
  }
  const location = useLocation();
  const { data, random } = location.state;

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleResendOtp = async () => {
    setTimer(120); // Reset timer
    setCanResend(false);
    setOtp(''); // Clear previous OTP
    try {
      const response = await axios.post(`${BASE_URL}/api/profile/send-otp`, {
        contact: localStorage.getItem('otpNumber'),
        status: "register",
      });

      if (response.status === 200) {
        toast.success('OTP Sent Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
      });
    }
  };

  const handleSubmit = async () => {
    if (!otp) {
      toast.error('Please Enter Otp!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    if (otp.length < 6) {
      toast.error('Please Enter Valid Otp!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    setLoading(true)

    try {
      const response = await axios.post(`${BASE_URL}/api/profile/verify-otp`, {
        contact: Number(localStorage.getItem('otpNumber')),
        otp: Number(otp),
      });

      if (response.status === 200) {
        try {
          const response = await axios.post(`${BASE_URL}/api/profile`, data, {
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (response.status === 200) {
            localStorage.setItem("saptvidhiUserToken", response.data.data.token);
            const currentDateAndTime = new Date().toLocaleDateString();
            localStorage.setItem("loginDateTime", currentDateAndTime);
            toast.success('Otp Verified Successfully', {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 1000,
            });
            setTimeout(() => {
              setLoading(false)
              navigate("/personal-deatils")
            }, 2000);
          } else {
            setLoading(false)
          }
        } catch (error) {
          setLoading(false)
          toast.error(error.response.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1000,
          });
        }
      } else {
        setLoading(false)
        toast.error('Failed to verify OTP. Please try again.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.response.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
      });
    }
  }

  return (
    <>
      <div className="otp_wrapper">
        <div className="otp_container">
          <h2>Enter OTP</h2>
          <input
            type="tel"
            maxLength="6"
            placeholder="OTP"
            className="otp_input"
            value={otp}
            onChange={handleChangeOtp}
            onInput={(e) => (e.target.value) = e.target.value.replace(/[^0-9]/g, '')}
          />

          <div className="timer_wrapper">
            {timer > 0 ? (
              <p className="timer_text">
                Time remaining: {Math.floor(timer/60)}:{(timer%60).toString().padStart(2, '0')}
              </p>
            ) : (
              <p className="timer_text">OTP expired. Please click resend.</p>
            )}
            
            {canResend && (
              <button 
                className="resend_button"
                onClick={handleResendOtp}
              >
                Resend OTP
              </button>
            )}
          </div>

          {loading ? (
            <button disabled={timer === 0}>
              <Loader />
            </button>
          ) : (
            <button 
              onClick={handleSubmit}
              disabled={timer === 0}
            >
              Submit
            </button>
          )}
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default Otp;
